function getCurrentVariantAvailability() {
  const variantDataEl = document.querySelector('[data-js-variant-data]');

  if (variantDataEl) {
    try {
      const variant = JSON.parse(variantDataEl.textContent);
      if (variant && typeof variant.available === 'boolean') {
        return variant;
      }
    } catch (error) {
      // Fall through to product-level availability.
    }
  }

  const productPage = document.querySelector('[data-js-product-component]');
  return {
    available: productPage?.dataset.availability === 'true'
  };
}

function updateProductStockUI() {
  const stockWrapper = document.querySelector('[data-js-product-stock]');
  if (!stockWrapper) return;

  const variant = getCurrentVariantAvailability();
  const variantAvailable = variant.available === true;
  const icon = stockWrapper.querySelector('[data-js-stock-icon]');
  const label = stockWrapper.querySelector('[data-js-stock-label]');
  const shippingText = stockWrapper.querySelector('[data-js-shipping-text]');
  const shippingEstimate = stockWrapper.querySelector('[data-js-shipping-estimate]');
  const lowThreshold = parseInt(stockWrapper.dataset.lowInventoryThreshold, 10) || 0;

  if (icon) {
    icon.classList.toggle('stock-green', variantAvailable);
    icon.classList.toggle('stock-red', !variantAvailable);
  }

  if (label) {
    if (variantAvailable) {
      if (
        variant.inventory_management &&
        variant.inventory_quantity > 0 &&
        variant.inventory_quantity <= lowThreshold
      ) {
        label.textContent = stockWrapper.dataset.lowStock;
      } else {
        label.textContent = stockWrapper.dataset.inStock;
      }
    } else {
      label.textContent = stockWrapper.dataset.outOfStock;
    }
  }

  if (shippingText) {
    shippingText.hidden = !variantAvailable;
  }

  if (shippingEstimate) {
    shippingEstimate.textContent = variantAvailable ? (stockWrapper.dataset.shippingTimeframe || '24 - 48 ore') : '';
  }
}

function initProductStockUI() {
  updateProductStockUI();

  document.querySelectorAll('product-variants').forEach((productVariants) => {
    productVariants.addEventListener('VARIANT_CHANGE', updateProductStockUI);
  });
}

document.addEventListener('DOMContentLoaded', initProductStockUI);

/* Product card - preselect the second option and hide it for visual purposes */

document.addEventListener('DOMContentLoaded', function () {
  const secondOption = document.querySelector('.product-variant.option--2');

  if (secondOption) {
    secondOption.style.display = 'none';
    const firstInput = secondOption.querySelector('input, select');
    if (firstInput) {
      firstInput.checked = true;
      firstInput.selected = true;
      firstInput.value = firstInput.value;
    }
  }
});

/* Shoppy videos slideshow */

const videoSlideshow = {
  mobileBreakpoint: 768,
  _splidePromise: null,

  ensureSplide() {
    if (typeof Splide !== 'undefined') {
      return Promise.resolve(true);
    }

    if (this._splidePromise) {
      return this._splidePromise;
    }

    this._splidePromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-shoppy-splide]');
      if (existing) {
        if (typeof Splide !== 'undefined') {
          resolve(true);
          return;
        }
        existing.addEventListener('load', () => resolve(true), { once: true });
        existing.addEventListener('error', () => reject(new Error('Splide failed to load')), {
          once: true
        });
        return;
      }

      if (!document.querySelector('link[data-shoppy-splide-css]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide-core.min.css';
        link.dataset.shoppySplideCss = '';
        document.head.appendChild(link);
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
      script.defer = true;
      script.dataset.shoppySplide = '';
      script.onload = () => resolve(true);
      script.onerror = () => reject(new Error('Splide failed to load'));
      document.head.appendChild(script);
    });

    return this._splidePromise;
  },

  stopSlide(slide) {
    if (!slide) return;

    const video = slide.querySelector('[data-js-video-element]');
    const iframeBox = slide.querySelector('[data-js-video-iframe-holder]');

    if (video) {
      video.pause();
      video.currentTime = 0;
      video.controls = false;
      video.removeAttribute('controls');
    }

    if (iframeBox) {
      iframeBox.innerHTML = '';
      iframeBox.classList.add('hide');
    }

    slide.classList.remove('is-playing', 'is-external');
  },

  isPlaying(slide) {
    return slide?.classList.contains('is-playing');
  },

  toggleSlide(slide, section) {
    if (!slide || slide.dataset.hasVideo !== 'true') return;

    if (this.isPlaying(slide)) {
      this.stopSlide(slide);
      return;
    }

    this.playSlide(slide, section);
  },

  stopAllExcept(section, activeSlide) {
    section.querySelectorAll('[data-shoppy-video-slide]').forEach((slide) => {
      if (slide !== activeSlide) this.stopSlide(slide);
    });
  },

  embedUrl(host, id) {
    if (host === 'youtube') {
      return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&playsinline=1&controls=1&rel=0`;
    }
    if (host === 'vimeo') {
      return `https://player.vimeo.com/video/${id}?autoplay=1&muted=1&controls=1`;
    }
    return '';
  },

  youtubePosterUrl(id) {
    return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  },

  async fetchVimeoPoster(id) {
    const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${id}`);
    if (!response.ok) return '';
    const data = await response.json();
    return data.thumbnail_url || '';
  },

  async loadExternalPoster(posterEl) {
    if (!posterEl || posterEl.querySelector('img')) return;

    const slide = posterEl.closest('[data-shoppy-video-slide]');
    if (!slide) return;

    const { externalHost: host, externalId: id } = slide.dataset;
    if (!host || !id) return;

    let url = host === 'youtube' ? this.youtubePosterUrl(id) : '';
    if (!url && host === 'vimeo') {
      try {
        url = await this.fetchVimeoPoster(id);
      } catch {
        url = '';
      }
    }

    if (!url) return;

    const img = document.createElement('img');
    img.className = 'shoppy-video-slide__poster-image';
    img.src = url;
    img.alt = '';
    img.loading = 'lazy';
    img.width = 720;
    img.height = 1280;
    posterEl.appendChild(img);

    slide.querySelector('.shoppy-video-slide__card')?.classList.remove('shoppy-video-slide__card--placeholder');
  },

  loadExternalPosters(section) {
    section.querySelectorAll('[data-js-external-poster]').forEach((posterEl) => {
      this.loadExternalPoster(posterEl);
    });
  },

  isAutoplayEnabled(section) {
    return section?.dataset.shoppyVideosAutoplay === 'true';
  },

  getActiveSlide(section, splide = null) {
    if (splide?.root) {
      return (
        splide.root.querySelector('.splide__slide.is-active:not(.shoppy-video-slide--duplicate)') ||
        splide.root.querySelector('.splide__slide.is-active')
      );
    }

    return section.querySelector(
      '.shoppy-videos-slideshow--single [data-shoppy-video-slide], [data-shoppy-video-slide].is-active'
    );
  },

  syncAutoplay(section, activeSlide = null) {
    if (!this.isAutoplayEnabled(section)) return;

    const slide = activeSlide || this.getActiveSlide(section, section._shoppySplide);
    if (!slide || slide.dataset.hasVideo !== 'true') return;

    this.playSlide(slide, section);
  },

  playSlide(slide, section) {
    if (!slide || slide.dataset.hasVideo !== 'true') return;

    this.stopAllExcept(section, slide);

    const video = slide.querySelector('[data-js-video-element]');
    const iframeBox = slide.querySelector('[data-js-video-iframe-holder]');
    const { externalHost: host, externalId: id } = slide.dataset;

    if (video) {
      slide.classList.add('is-playing');
      video.controls = true;
      video.setAttribute('controls', '');
      video.play().catch(() => this.stopSlide(slide));
      return;
    }

    const src = this.embedUrl(host, id);
    if (!src || !iframeBox) return;

    iframeBox.innerHTML = `<iframe src="${src}" allow="autoplay; encrypted-media; fullscreen" allowfullscreen title="Video"></iframe>`;
    iframeBox.classList.remove('hide');
    slide.classList.add('is-playing', 'is-external');
  },

  getLayout(root) {
    const width = root.clientWidth || window.innerWidth;
    const mobile = width < this.mobileBreakpoint;
    const gap = mobile ? 3 : 27;
    const peek = mobile ? 0.2 : 0.4;
    const fullCount = mobile ? 1 : 3;
    const gapCount = mobile ? 2 : 4;
    const units = fullCount + peek * 2;
    const min = mobile ? 140 : 160;
    const slideWidth = Math.max(min, Math.round((width - gapCount * gap) / units));

    return {
      fixedWidth: `${slideWidth}px`,
      gap: `${gap}px`,
      padding: { left: 0, right: 0 }
    };
  },

  uniquifyCloneIds(slide, suffix) {
    slide.removeAttribute('id');

    const ids = [...slide.querySelectorAll('[id]')].map((node) => node.id);
    ids.forEach((oldId) => {
      slide.innerHTML = slide.innerHTML.replaceAll(oldId, `${oldId}-${suffix}`);
    });
  },

  prepareSlideList(list) {
    const originals = [...list.children];
    const count = originals.length;
    if (count < 1 || count >= 3) return count;

    let cloneIndex = 0;
    while (list.children.length < 3) {
      const source = originals[cloneIndex % count];
      const clone = source.cloneNode(true);
      clone.classList.add('shoppy-video-slide--duplicate');
      clone.removeAttribute('data-shopify-editor-block');
      this.uniquifyCloneIds(clone, `dup-${cloneIndex}`);
      list.appendChild(clone);
      cloneIndex += 1;
    }

    return list.children.length;
  },

  syncScaleClasses(splide) {
    const track = splide.root.querySelector('.splide__track');
    const slides = [...splide.root.querySelectorAll('.splide__slide')];
    if (!track || !slides.length) return;

    const center = track.getBoundingClientRect().left + track.clientWidth / 2;
    const ranked = slides
      .map((slide) => {
        const rect = slide.getBoundingClientRect();
        return {
          slide,
          dist: Math.abs(rect.left + rect.width / 2 - center)
        };
      })
      .sort((a, b) => a.dist - b.dist);

    slides.forEach((slide) => {
      slide.classList.remove('is-active', 'is-visible');
    });

    ranked[0]?.slide.classList.add('is-active');
    ranked[1]?.slide.classList.add('is-visible');
    ranked[2]?.slide.classList.add('is-visible');
  },

  scheduleScaleSync(splide) {
    if (splide._scaleSyncFrame) return;
    splide._scaleSyncFrame = requestAnimationFrame(() => {
      splide._scaleSyncFrame = null;
      this.syncScaleClasses(splide);
    });
  },

  onCarouselChange(splide, section, index = splide.index) {
    splide.Components?.Slides?.update?.();
    this.syncScaleClasses(splide);
    const active =
      splide.root.querySelector('.splide__slide.is-active') ||
      splide.Components?.Slides?.getAt(index)?.slide;
    this.stopAllExcept(section, active);
    this.syncAutoplay(section, active);
  },

  applyLayout(splide, section) {
    const layout = this.getLayout(splide.root);
    Object.assign(splide.options, layout);
    splide.refresh();
    this.onCarouselChange(splide, section);
  },

  mount(section) {
    const root = section.querySelector('.shoppy-videos-splide');
    if (!root || typeof Splide === 'undefined') {
      return false;
    }

    if (section._shoppySplide) {
      try {
        section._shoppySplide.destroy(true);
      } catch (error) {
      }
      section._shoppySplide = null;
    }

    delete root.dataset.shoppySplideMounted;

    const list = root.querySelector('.splide__list');
    if (list) this.prepareSlideList(list);

    const layout = this.getLayout(root);
    const splide = new Splide(root, {
      type: 'loop',
      focus: 'center',
      fixedWidth: layout.fixedWidth,
      gap: layout.gap,
      padding: layout.padding,
      perMove: 1,
      pagination: false,
      arrows: false,
      trimSpace: false,
      updateOnMove: true,
      drag: true
    });

    splide.on('move', (_from, _to, dest) => this.onCarouselChange(splide, section, dest));
    splide.on('drag', () => this.scheduleScaleSync(splide));
    splide.on('scrolling', () => this.scheduleScaleSync(splide));
    splide.on('moved', () => this.onCarouselChange(splide, section));
    splide.on('mounted', () => {
      this.applyLayout(splide, section);
      splide.go(splide.index);
      this.syncScaleClasses(splide);
    });

    splide.mount();
    root.dataset.shoppySplideMounted = 'true';
    section._shoppySplide = splide;
    this.syncScaleClasses(splide);
    this.loadExternalPosters(section);

    if (!section._shoppySplideResizeHandler) {
      section._shoppySplideResizeHandler = () => {
        if (section._shoppySplide) this.applyLayout(section._shoppySplide, section);
      };
      window.addEventListener('resize', section._shoppySplideResizeHandler);
    }

    return true;
  },

  async bindSection(section) {
    const root = section.querySelector('.shoppy-videos-splide');
    const single = section.querySelector('.shoppy-videos-slideshow--single');
    if (!root && !single) return;

    if (section.dataset.shoppyVideosBound !== 'true') {
      section.dataset.shoppyVideosBound = 'true';
      section.addEventListener('click', (event) => {
        const slide = event.target.closest('[data-shoppy-video-slide]');
        if (!slide || slide.dataset.hasVideo !== 'true') return;

        if (event.target.closest('[data-js-video-play]')) {
          event.preventDefault();
          this.toggleSlide(slide, section);
        }
      });
    }

    this.loadExternalPosters(section);

    if (!root) {
      this.syncAutoplay(section);
      return;
    }

    try {
      await this.ensureSplide();
      this.mount(section);
    } catch (error) {
      console.warn('[Shoppy videos slideshow] Splide unavailable', error);
    }
  },

  async refreshSection(section) {
    if (!section) return;
    this.destroy(section);
    await new Promise((resolve) => requestAnimationFrame(resolve));
    await this.bindSection(section);
  },

  init(scope = document) {
    scope.querySelectorAll('[data-shoppy-videos-slideshow]').forEach((section) => {
      void this.bindSection(section);
    });
  },

  destroy(section) {
    if (!section) return;

    if (section._shoppySplideResizeHandler) {
      window.removeEventListener('resize', section._shoppySplideResizeHandler);
      section._shoppySplideResizeHandler = null;
    }

    if (section._shoppySplide) {
      try {
        section._shoppySplide.destroy(true);
      } catch (error) {
        // Ignore teardown errors during theme editor refreshes.
      }
      section._shoppySplide = null;
    }

    const root = section.querySelector('.shoppy-videos-splide');
    if (root) {
      delete root.dataset.shoppySplideMounted;
    }

    delete section.dataset.shoppyVideosBound;
  }
};

document.addEventListener('DOMContentLoaded', () => videoSlideshow.init());
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-shoppy-videos-slideshow]').forEach((section) => {
    void videoSlideshow.refreshSection(section);
  });
});
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-shoppy-videos-slideshow]').forEach((section) => {
    videoSlideshow.destroy(section);
  });
});
document.addEventListener('shopify:section:reorder', (event) => {
  event.target.querySelectorAll('[data-shoppy-videos-slideshow]').forEach((section) => {
    void videoSlideshow.refreshSection(section);
  });
});
document.addEventListener('shopify:block:deselect', (event) => {
  const section = event.target.closest('[data-shoppy-videos-slideshow]');
  if (section) {
    setTimeout(() => {
      void videoSlideshow.refreshSection(section);
    }, 100);
  }
});
